import * as type from 'app/actionTypes/gateways';

export function getBasicGateways() {
    return {
        type: type.GET_GATEWAYS_REQUESTED,
    }
}
